import './paedml-card.tag'
import './paedml-icon-modal.tag'
import './hub/paedml-modal-hub-parameters.tag'
import './hub/paedml-hub-upload-parameter.tag'
import './hub/paedml-modal-update-hub.tag'

<paedml-card-hubparameter>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings}>

    <virtual if={canCreate()}>
      <paedml-icon-modal icon="anlegen" target="#{prefix}-create-modal" title="Parameter anlegen" />
      <paedml-modal-hub-parameters prefix="{prefix}-create" 
        heading="{config.contentTitle}: Parameter anlegen" opname="Parameter anlegen" api={restApi} />
    </virtual>

    <virtual if={canEdit()}>
      <paedml-icon-modal icon="bearbeiten" target="#{prefix}-edit-modal" title="Parameter bearbeiten" />
      <paedml-modal-hub-parameters prefix="{prefix}-edit" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Parameter bearbeiten" opname="Änderung speichern" api={restApi} />
    </virtual>

    <virtual if={canDelete() && parent.canBeDeleted(this)}>
      <paedml-icon-modal icon="loeschen" target="#{prefix}-delete-modal" title="Parameter löschen" />
      <paedml-modal-delete heading="{config.contentTitle}: Parameter löschen" prefix="{prefix}-delete" 
        patient="{{singular: 'Parameter', plural: 'Parameter', as: 'das'}}" selectedrowsfunc={getSelectedRows} api={restApi} relogin={true}/>
    </virtual>

    <virtual if={isPermitted('upload')}>
      <paedml-icon-modal icon="fas-file-upload" target="#{prefix}-upload-parameters-modal" title="Parameter und Host-Parameter hochladen" />
      <paedml-hub-upload-parameter prefix="{prefix}-upload-parameters"
        heading="{config.contentTitle}: Parameter und Host-Parameter hochladen" opname="Parameter und Host-Parameter hochladen" api={restApi}
      />
    </virtual>

    <virtual if={isPermitted('upload')}>
      <paedml-icon-modal icon="fas-upload" target="#{prefix}-update-hub-modal" title="paed.ML Hub Systemupdate" />
      <paedml-modal-update-hub prefix="{prefix}-update-hub" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: paed.ML Hub Systemupdate" opname="Update starten" api={restApi}
      />
    </virtual>

  </paedml-card>

    <script>
    import Session from '../store/session'
    this.api = this.opts.api

    this.session = Session

    this.prefix = opts.prefix

    this.canBeDeleted = (ctx) => ctx.atLeastOnePositiveValueInColumn(4)

  </script>
</paedml-card-hubparameter>
